import configureGooglePlaces from '@/config/googlePlaces';
import settings from '@/constants/constants';
import { getAppEnv, getFormConfig } from '@/constants/env';
import { FF_ENABLE_SNOWPLOW } from '@/constants/featureFlags';
import useFeatureFlags from '@/hooks/useFeatureFlags';
import { AppProviders } from '@/providers/AppProviders';
import { AppRoutes } from '@/routes/AppRoutes';
import { Box, CircularProgress } from '@montugroup/design-system';
import useTrackingProviders from './hooks/useTrackingProviders';
import { formatStringToSha256Hash } from './utils/ga-hashing';

const App = () => {
  const appEnv = getAppEnv();
  const isProduction = appEnv === 'production';
  const targetForm = getFormConfig();
  useTrackingProviders(settings);

  // Feature flag setup
  const { flags, loading: isFeatureFlagsLoading } = useFeatureFlags();
  const ffEnableSnowplow = flags[FF_ENABLE_SNOWPLOW];

  // Read query param for Snowplow userId
  const queryParams = new URLSearchParams(window.location.search);
  const userEmailParam = queryParams.get('email') || undefined;
  const hashedUserEmail = userEmailParam ? formatStringToSha256Hash(userEmailParam) : undefined;

  // Config Google Places (used for LocationInput autocomplete field)
  configureGooglePlaces(settings);

  if (isFeatureFlagsLoading) {
    return (
      <Box sx={{ display: 'flex', height: '100vh', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress color="inherit" />
      </Box>
    );
  }

  return (
    <AppProviders flags={flags} hashedUserEmail={hashedUserEmail} enableSnowplow={ffEnableSnowplow}>
      <AppRoutes targetForm={targetForm} isProduction={isProduction} />
    </AppProviders>
  );
};

export default App;
